import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const PlaceLabel = ({
  x,
  y,
  data,
}: {
  x: number
  y: number
  data: MapLabelType
}) => {
  const { width } = useWindowSize()
  const { label, offset, type } = data

  const circlerad = width < 712 ? 3 : 5
  const offsetbase = width < 712 ? 9 : type !== 'city' ? 9 : 9
  let offs = [0, 0],
    lineoffs = [0, 4],
    anchor = 'center'
  if (offset) {
    if (offset.includes('top')) {
      offs[1] = -offsetbase * 2
      if (offset === 'top') offs[1] = -offsetbase * 3
      anchor = 'middle'
    }
    if (offset.includes('bottom')) {
      offs[1] = offsetbase * 3
      lineoffs[1] = -12
      anchor = 'middle'
    }
    if (offset.includes('left')) {
      offs[0] = -offsetbase
      anchor = 'end'
      if (!offset.includes('bottom') && !offset.includes('top')) {
        offs[0] = -offsetbase * 2
        offs[1] = -4
      }
    }
    if (offset.includes('right')) {
      offs[0] = offsetbase
      anchor = 'start'
      if (!offset.includes('bottom') && !offset.includes('top')) {
        offs[0] = offsetbase * 2
        offs[1] = -4
      }
    }
  }
  return (
    <PlaceLabelGroup
      transform={`translate(${x},${y})`}
    >
      {/* <circle cx={0} cy={0} r={circlerad} /> */}
      {/* {type === 'event' && (
        <>
          <rect
            transform={`translate(${offs[0]},${offs[1] - 18})`}
            width={160}
            height={26}
            x={-80}
          />
          <MarkerLine
            x1={0}
            x2={offs[0] + lineoffs[0]}
            y1={0}
            y2={offs[1] + lineoffs[1]}
            stroke={'#7D7D7D'}
            strokeWidth={1}
          />
          <text className='event' textAnchor={anchor} fontWeight={700}>
            {label}
          </text>
        </>
      )} */}
      {type === 'event' && (
        <>
          <circle r={12} cy={-10} />
          <g transform={`translate(${offs[0]},${offs[1]})`}>
            <text className='eventbg' textAnchor={anchor} fontWeight={700}>
              {label}
            </text>
            <text className='event' textAnchor={anchor} fontWeight={700}>
              {label}
            </text>
          </g>
        </>
      )}
      <Label transform={type==="city"?"translate(0,0)":`translate(${offs[0]},${offs[1]})`}>
        {type === 'country' && (
          <>
            <text className='countrybg' textAnchor={anchor}>
              {label}
            </text>
            <text className='country' textAnchor={anchor}>
              {label}
            </text>
          </>
        )}
        {type === 'region' && (
          <>
            {/* <text className='regionbg' textAnchor={anchor}>
              {label}
            </text> */}
            <text className='region' textAnchor={'middle'}>
              {label}
            </text>
          </>
        )}
        {type === 'city' && (
          <>
            <text className='citybg' textAnchor={'middle'}>
              {label}
            </text>
            <text className='city' textAnchor={'middle'}>
              {label}
            </text>
          </>
        )}
      </Label>
    </PlaceLabelGroup>
  )
}
const MarkerLine = styled.line`
  stroke: var(--text-color);
`
const Label = styled.g``
const PlaceLabelGroup = styled.g`
  font-size: 15px;
  /* font-weight: 700; */
  font-family: var(--font-sans-serif);
  fill: var(--text-color);
  text {
    letter-spacing: 0.1px;
    font-size: 18px;
  }
  rect {
    fill: var(--text-color);
  }
  circle {
    fill: none;
    stroke: var(--text-color);
    opacity: 1;
    stroke-width: 1.5;
  }
  text.countrybg {
    stroke: var(--site-background);
    font-weight: 200;
    text-transform: uppercase;
    font-size: 30px;
    font-weight: 200;
  }
  text.country {
    fill: var(--beige-main);
    font-weight: 200;
    text-transform: uppercase;
    font-size: 30px;
    @media only screen and (max-width: 711px) {
      font-size: 18px;
    }
  }
  text.regionbg {
    stroke: var(--site-background);
    font-weight: 200;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 200;
  }
  text.region {
    fill: var(--text-color);
    /* text-transform: uppercase; */
    font-size: 18px;
    font-style: italic;
    opacity: 0.5;
    @media only screen and (max-width: 711px) {
      font-size: 15px;
    }
  }
  text.eventbg {
    stroke: var(--site-background);
    fill: var(--site-background);
    stroke-width: 2;
    @media only screen and (max-width: 711px) {
      font-size: 15px;
    }
  }
  text.event {
    fill: var(--text-color);
    @media only screen and (max-width: 711px) {
      font-size: 15px;
    }
  }
  text.citybg {
    font-weight: 200;
    letter-spacing: 0.6px;
    stroke: var(--site-background);
    stroke-width: 3;
    font-size: 18px;
    font-style: italic;
    @media only screen and (max-width: 711px) {
      font-size: 15px;
      opacity: .5;
    }
  }
  text.city {
    font-weight: 200;
    letter-spacing: 0.6px;

    font-size: 18px;
    stroke: var(--text-color);
    font-style: italic;
    @media only screen and (max-width: 711px) {
      font-size: 15px;      opacity: .7;

    }
  }
`
